import React, { Component } from 'react';

import './Configurator.css';
import './../components/ConfiguratorPanel.css';
import './../components/react-tabs.css';

import Actions from './../flux/Actions';
import Store from './../flux/Store';

import { __ } from "../Translator";
import { imageToBase64, resizeImage, randomId } from '../Helpers';
import canvas2svg from 'canvas2svg';

import EmersyaQueue from './../EmersyaQueue';
import InlineSvg from "../InlineSvg";
import ColorPalette from './../components/ColorPalette';
import AccessoryPalette from './../components/AccessoryPalette';
import Footer from "../components/Footer";
import ProductPresetSlider from "../components/ProductPresetSlider";
import Header from "../components/Header";
import StepIndicator from "../components/StepIndicator";
import Modal from "../components/Modal";

import BackIcon from "./../img/icon-footer-back.svg";
import InfoIcon from "./../img/info.svg";
import TransferSample from "./../img/transfer.png";
import LeatherPatchSample from "./../img/leatherpatch.png";
import ConfiguratorMenuItemArrow from './../img/configurator-menu-item-arrow.svg';
import AppStore from "../flux/AppStore";
import AppActions from "../flux/AppActions";
import Dropdown from "../components/Dropdown";
import PatchConfigurator from "../components/PatchConfigurator";
import { _FONTS as FONTS } from "../components/TextPatchConfigurator";

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs/esm/index';
import ViewerStore from '../flux/ViewerStore';
import Emersya from '../Emersya';
import isNotIronGray from '../utils/isNotIronGray';

import CountryStore from '../flux/CountryStore';
import shouldShowPrice from '../utils/shouldShowPrice';
import { roundNumber} from "../Helpers";
import currencySymbol from '../utils/currencySymbol';



class Configurator extends Component {
  constructor(props) {
    super(props);

    this.state = {
      customProduct: AppStore.getCustomProduct(),

      viewer: ViewerStore.getState(),

      // Configurator
      menuItemActive: null,
      selectedSpecification: null,
      isPosingForScreenshot: false,
      accessoryTypeList: [],

      // Modal
      isCustomProductSaveNewOrUpdateModalVisible: false,
      isPatchModalVisible: false,

      // PatchError
      isErrorImagePatchVisible: false,

      patchConfigurationIndex: 0,
    };

    this.emersyaBridge = new Emersya(this.state.viewer.reference);

    // IFrame
    this.viewerActive = false;
    this.viewerIframe = this.state.viewer.reference;

    this.viewerCurrentConfiguration = null;

    // When selecting a part, we keep it highlighted until the first material
    // is applied.
    this.selectedHighlightedSpecificationName = null;

    // Stored momentarily
    this.customProductSpecification = null;

    this.accessoriesCategory = {
      'SHOULDER_PLATE': 'SHOULDER_PLATE',
      'ELBOW_PLATE': 'ELBOW_PLATE',
      'ELBOW_SLIDER': 'ELBOW_SLIDER',
      'KNEE_SLIDER': 'KNEE_SLIDER',
      'KNEE_PLATE': 'KNEE_PLATE',
      'PRINT': 'PRINT',
      'SPEED_DEMON_CHEST' : 'SPEED_DEMON_CHEST',
      'SPEED_DEMON_GOBBA' : 'SPEED_DEMON_GOBBA',
    };

    this.partTypeToMenuItem = {
      'PART': 'leathers',
      'CUSTOM_PATCH': 'patches',
      ...this.accessoriesCategory
    };

    //
    this.emersyaQueue = new EmersyaQueue();

    // Component
    this.updatePart = this.updatePart.bind(this);
    this.getPartSpecificationByCode = this.getPartSpecificationByCode.bind(this);
    this.onWindowMessage = this.onWindowMessage.bind(this);

    // Data
    this.subscriptions = [];
    this.onCustomProductStored = this.onCustomProductStored.bind(this);
    this.onCustomProductUpdated = this.onCustomProductUpdated.bind(this);
    this.registerViewerCallback = this.registerViewerCallback.bind(this);
    this.onViewerChange = this.onViewerChange.bind(this);

    // UI
    this.onPatchClick = this.onPatchClick.bind(this);
    this.onPatchImageChange = this.onPatchImageChange.bind(this);
    // this.updateProductConfiguration = this.updateProductConfiguration.bind(this);
    this.onPatchConfigurationClick = this.onPatchConfigurationClick.bind(this);

    // this.takeScreenshotFrontBack = this.takeScreenshotFrontBack.bind(this);
    // this.customProductSaveNewOrUpdate = this.customProductSaveNewOrUpdate.bind(this);
    // this.onCreateCustomProductClick = this.onCreateCustomProductClick.bind(this);
    // this.onCustomProductSaveClick = this.onCustomProductSaveClick.bind(this);
  }

  componentDidMount() {
    this.viewerIframe = this.state.viewer.reference.contentWindow;

    if (this.state.customProduct.country_id) {
      AppActions.updateCountry(this.state.customProduct.country_id);
    }

    if (this.state.viewer.code === this.state.customProduct.product.code) {
      this.viewerActive = true;
    } else {
      // If the viewer is not ready, we show the overlay and attach a "load"
      // event to it which will initialize the communication from the viewer
      // to our application.
      AppActions.showLoadingScreenOverlay(__('Loading 3D viewer…'));

      // We load the product into the viewer if it's not already loaded or loading
      AppActions.loadProductInViewer(this.state.customProduct.product.code);

      this.state.viewer.reference
        .addEventListener('load', this.registerViewerCallback, false);
    }

    this.setState({
      accessoryTypeList: this.getAccessoryTypeList(),
    });

    window.addEventListener('message', this.onWindowMessage);
    Store.events.createCustomProduct.addListener(this.onCustomProductStored);
    AppStore.events.updateCustomProduct.addListener(this.onCustomProductUpdated);

    this.subscriptions.push(ViewerStore.addListener(this.onViewerChange));
  }

  componentWillUnmount() {
    this.state.viewer.reference
      .removeEventListener('load', this.registerViewerCallback, false);

    window.removeEventListener('message', this.onWindowMessage);
    Store.events.createCustomProduct.removeListener(this.onCustomProductStored);
    AppStore.events.updateCustomProduct.removeListener(this.onCustomProductUpdated);

    this.subscriptions.forEach(subscription => subscription.remove());

    // We make sure the product is in its default position when the page is
    // loaded.
    this.postMessageToViewer({ action: 'setDefaultView' });
  }

  /**
   * Invoked when the custom product changes locally (through the
   * AppActions.updateCustomProduct action), Updates the component's state with
   * the latest custom product.
   */
  onCustomProductUpdated() {
    this.setState({
      customProduct: AppStore.getCustomProduct(),
      accessoryTypeList: this.getAccessoryTypeList(),
    });
  }

  /**
   * Invoked once the custom product has been stored on the server. Hides the
   * loading overlay and changes Screen to show the next step.
   */
  onCustomProductStored() {
    AppActions.hideLoadingScreenOverlay();

    this.props.navigation.navigate('mailinsert');
  }

  /**
   * Invoked after the "Save customization" in the footer is clicked (note that
   * that button show a modal). Save the customization on the server.
   *
   * @param {object} customProductSpecification
   */
  onCreateCustomProductClick(customProductSpecification) {
    this.customProductSaveNewOrUpdate(true, customProductSpecification);
  }

  /**
   * Invoked when the "Update" button in the modal is clicked. Updates the
   * customization on the server.
   * The modal is shown after the "Save customization" button in the footer is
   * clicked.
   *
   * @param {string} hash The custom product hash
   * @param {object} customProductSpecification
   */
  onUpdateCustomProductClick(hash, customProductSpecification) {
    this.customProductSaveNewOrUpdate(false, customProductSpecification, hash);
  }

  onViewerChange() {
    this.setState({ viewer: ViewerStore.getState() });
  }

  /**
   * For the given product specification return all the types of accessories
   * found.
   *
   * @returns {Array} The list of types of accessories
   */
  getAccessoryTypeList() {
    if ( ! (this.state.customProduct && this.state.customProduct.product)) {
      return [];
    }

    // Extracts all the flags from the "specification" object and removes the
    // duplicates
    const specificationPartFlags = Object.keys(this.state.customProduct.product.specification).reduce((carry, sk) => {
        return carry.concat(this.state.customProduct.product.specification[sk].flags);
      }, []).filter(function(value, index, self) {
          return self.indexOf(value) === index;
      });

    return Object.keys(this.accessoriesCategory).filter(category => {
      return specificationPartFlags.indexOf(category) !== -1;
    })
  }

  /**
   * Create or update a custom product.
   *
   * @param {boolean} isCreating
   * @param {object} customProductSpecification
   * @param {string|null} hash Required if `isCreating` is `false`
   */
  customProductSaveNewOrUpdate(isCreating, customProductSpecification, hash = null) {
    AppActions.showLoadingScreenOverlay(__('Taking screenshots…'));

    const onScreenshotsTaken = screenshots  => {
      customProductSpecification.screenshots = {
        front: screenshots[1],
        back: screenshots[0],
        left: screenshots[2],
        right: screenshots[3],
      };

      if (isCreating) {
        AppActions.updateCustomProduct({
          productCode: this.state.customProduct.product.code,
          productPresetName: this.state.customProduct.preset,
          perforated: this.state.customProduct.perforated,
          custom_colored: this.state.customProduct.custom_colored,
          specification: customProductSpecification.specification.map(part => ({
            key: part.key,
            type: part.type,
            material: part.material,
            partCode: part.key,
          })),
          files: customProductSpecification.files,
          texts: customProductSpecification.texts,
          screenshots: customProductSpecification.screenshots
        });

        AppActions.hideLoadingScreenOverlay();

        this.props.navigation.navigate('mailinsert');
      } else {
        AppActions.showLoadingScreenOverlay(__('Updating customization…'));
        Actions.updateCustomProduct(hash, customProductSpecification);
      }
    }

    const onError = error => {
      console.error(error);
      AppActions.hideLoadingScreenOverlay();
      this.setState({ isCustomProductSaveNewOrUpdateErrorModalVisible: true })
    };

    this.takeScreenshotFrontBack(onScreenshotsTaken, onError);

    this.setState({ isCustomProductSaveNewOrUpdateModalVisible: false });
  }

  /**
   * Whether or not the user can interact with the 3D viewer.
   *
   * @returns {boolean}
   */
  canInteractWithViewer() {
    return this.viewerActive && ( ! this.state.isPosingForScreenshot);
  }

  /**
   * Hide the item if active, otherwise show it if the customProduct has
   * finished loading.
   *
   * @param {string} item
   */
  toggleMenuItem(item) {
    this.setState({
      menuItemActive: this.state.menuItemActive === item
        ? null
        : this.state.customProduct.product ? item : null,
    });
  }

  /**
   * Hide the item if active, do nothing otherwise.
   *
   * @param {string|null} item
   */
  closeMenuItem(item) {
    this.setState({
      menuItemActive: this.state.menuItemActive === item ? null : this.state.menuItemActive,
    });
  }

  /**
   * Initializes the product and hides the loading overlay. If a custom product
   * has been provided we're going to use it, otherwise the default preset.
   */
  async onViewerLoaded() {
    let simpleSpecification;

    if (this.state.customProduct.hash) {
      simpleSpecification = {
        specification: this.state.customProduct.simpleSpecification,
        files: this.state.customProduct.files,
        texts: this.state.customProduct.texts,
      };
    } else {
      const preset = false; // Store.getPresets(this.state.customProduct.product.code, this.state.customProduct.preset);
      simpleSpecification = {
        specification: preset ? preset.specification : [],
        files: [],
        texts: [],
      };
    }

    const specifications = await this.emersyaBridge.getCurrentMaterialTreesGroupsConfiguration();

    // @todo 2017-12-06 Can we use let?
    var productSpecification = this.state.customProduct.product;

    specifications.forEach(_specification => {
      const specification = productSpecification.specification[_specification.groupName];

      if ( ! (specification && specification.combinations[_specification.configurationName] !== undefined)) {
        console.warn('Invalid combination key.', arguments);
        return;
      }

      specification.active_combination = _specification.configurationName;
      productSpecification.specification[_specification.groupName] = specification;
    });

    AppActions.updateCustomProduct({ product: productSpecification });

    await this.updateProductFromSimpleSpecification(simpleSpecification);

    this.viewerActive = true;

    AppActions.hideLoadingScreenOverlay();
  }

  registerViewerCallback() {
    this.postMessageToViewer({ action: 'registerCallback' });
  }

  onWindowMessage(event) {
    if ( ! (event && event.data)) {
      return;
    }

    this.emersyaQueue.stateChanged(event.data.id, event.data);

    switch (event.data.action) {
      case "onError":
        console.error('Error', event);
        // throw new Error(event.data.message);

      case "onStateChange": {
        if (event.data.state === undefined) {
          console.warn("event.data.state is undefined", [event.data]);
        } else if (event.data.state.viewerState === 'loaded') {
          this.onViewerLoaded().catch(console.error);
        }else{
          console.warn("Cannot read properties of undefined (reading 'viewerState')", [event.data]);
        }
        break;
      }

      case 'onMaterialTreesGroupHighlight': {
        if ( ! event.data.materialTreesGroupsName) {
          return;
        }

        const groupsName = event.data.materialTreesGroupsName[0];

        const materialTreeGroups = this.getPartSpecificationByCode(groupsName)
          ? event.data.materialTreesGroupsName
          : [];

        if (this.selectedHighlightedSpecificationName) {
          materialTreeGroups.push(this.selectedHighlightedSpecificationName);
        }

        this.postMessageToViewer({
          action: 'setHighlight',
          polylists: [],
          materialTrees: [],
          materialTreeGroups,
        });

        break;
      }

      case "onPolylistHighlight": {
        if ( ! this.canInteractWithViewer()) {
          return;
        }

        const selectedSpecification = this.getPartSpecificationByCode(event.data.polylistName[0]);

        // This event is only needed for custom patches, everything else is
        // handled in the "onMaterialTreesGroupHighlight" case.
        if ( ! (selectedSpecification !== undefined && selectedSpecification.type === 'CUSTOM_PATCH')) {
          return;
        }

        const id = randomId();

        // @todo 2017-11-24 Does setTimeout work? Really? It seems to
        this.emersyaQueue.queue(() => {
          setTimeout(() => {
            this.postMessageToViewer({
              id,
              action: 'setHighlightByName',
              list: [selectedSpecification.name]
            });
          }, 0);
        }, id, 'setHighlightByName');

        break;
      }

      case "onPolylistSelection": {
        if ( ! this.canInteractWithViewer()) {
          return;
        }

        const partCode =
          event.data.materialTreesGroupName[0] ||
          event.data.materialTreeName[0];

        const selectedSpecification = this.getPartSpecificationByCode(partCode);

        if (selectedSpecification === undefined) {
          this.setState({
            menuItemActive: null,
            selectedSpecification: null,
          });

          this.setSelectedHighlightedSpecificationName(null);

          const queueId = randomId();
          this.hideHighlightedPatches(partCode, queueId);
          this.emersyaQueue.run(queueId);

          return;
        }

        if (selectedSpecification.type === 'CUSTOM_PATCH') {
          this.onPatchClick(selectedSpecification.name, selectedSpecification.active_combination);
        } else {
          const queueId = randomId();
          this.hideHighlightedPatches(partCode, queueId);
          this.emersyaQueue.run(queueId);
        }

        const selectedSpecificationType = selectedSpecification.type === 'ACCESSORY'
          ? this.getAccessoryTypeByFlags(selectedSpecification.flags)
          : selectedSpecification.type;

        this.setSelectedHighlightedSpecificationName(selectedSpecification.name);

        // The Tab component used (react-tabs) only accepts a numeric index to
        // specify the active tab.
        let patchConfigurationIndex = 0;

        if (selectedSpecification.type === 'CUSTOM_PATCH') {
          // We get the index by getting all the patches in the current active
          // specification and finding the partCode index inside there.
          const combinationSpecification = selectedSpecification
            .combinations[selectedSpecification.active_combination]
            .specification;

          patchConfigurationIndex = Object.keys(combinationSpecification).indexOf(partCode);
        }
        this.setState({
          menuItemActive: this.partTypeToMenuItem[selectedSpecificationType],
          selectedSpecification,
          patchConfigurationIndex,
        });
        break;
      }

      default:
        // console.log('Unhandled window event "message"', event);

        // if (event.data.action && event.data.action.indexOf("Camera") === -1) {
          // console.log("log: " + event.data.action);
          // console.log(event.data);
        // }
    }
  }

  /**
   * Invoked when a patch is clicked or chosen (3D viewer or UI).
   *
   * @param {string} specificationKey The part key
   * @param {string|null} activeCombination The active combination of the patch,
   *     the first combination will be used if `activeCombination` is null
   */
  onPatchClick(specificationKey, activeCombination = null) {
    const combinationKey = activeCombination || Object.keys(
      this.state.customProduct.product.specification[specificationKey].combinations
    )[0];

    this.onPatchConfigurationClick(specificationKey, combinationKey);
  }

  /**
   * Invoked when a patch configuration is clicked. Hides the visible
   * highlights, and highlight the current configuration patches without an
   * image nor text. Then rotates the model to focus the selected patch.
   *
   * @param {string} specificationKey The part key
   * @param {string} combinationKey The part active configuration
   */
  onPatchConfigurationClick(specificationKey, combinationKey) {
    let selectedSpecification = this.state.customProduct.product.specification[specificationKey];
    const lastActiveCombination = selectedSpecification.active_combination;

    const queueId = randomId();

    // Remove the highlighted and unused patch
    this.hideHighlightedPatches(combinationKey, queueId);

    this.setSelectedHighlightedSpecificationName(null);

    this.emersyaQueue.queue(() => {
      this.postMessageToViewer({
        id: queueId,
        action: 'beginTransaction'
      });

      this.forEachPartInCombination(selectedSpecification.combinations, (_combinationKey, _combinationSpecificationKey) => {
        if (_combinationKey !== combinationKey) {
          this.postMessageToViewer({
            action: 'setMaterialByName',
            materialSettings: `${_combinationSpecificationKey}/transparent`
          });
        } else if ( ! selectedSpecification.combinations[_combinationKey].specification[_combinationSpecificationKey].modified) {
          this.postMessageToViewer({
            action: 'setMaterialByName',
            materialSettings: `${_combinationSpecificationKey}/highlight`
          });
        } else {
          // Is the same patch, don't need to change anything
        }
      });

      this.postMessageToViewer({
        id: queueId,
        action: 'endTransaction'
      });
    }, queueId, 'transaction');

    // @todo 2017-09-11 Shouldn't we also update customProduct.product?
    selectedSpecification.active_combination = combinationKey;

    this.setState({ selectedSpecification, patchConfigurationIndex: 0 }, () => {
      // Removes the old state of the just selected patches
      if (lastActiveCombination !== combinationKey) {
        const lastCombination = selectedSpecification.combinations[lastActiveCombination];

        if (lastCombination) {
          for (const combinationSpecificationKey of Object.keys(lastCombination.specification)) {
            this.removePatchImage(specificationKey, lastActiveCombination, combinationSpecificationKey, queueId);
          }
        }
      }
    });

    this.highlightProductPartList(
      Object.keys(
        selectedSpecification.combinations[combinationKey].specification
      ).filter(combinationSpecificationKey => {
        return ! selectedSpecification.combinations[combinationKey].specification[combinationSpecificationKey].modified;
      })
    );

    const viewpoint = this.state.customProduct.product.viewpoints[selectedSpecification.viewpoint_id];

    this.emersyaQueue.queue(() => {
      this.postMessageToViewer({
        id: queueId,
        action: 'setCamera',
        position: [viewpoint.position_x, viewpoint.position_y, viewpoint.position_z],
        target: [viewpoint.target_x, viewpoint.target_y, viewpoint.target_z],
        up: [viewpoint.up_x, viewpoint.up_y, viewpoint.up_z],
        fov: viewpoint.fov,
        transitionTime: viewpoint.transition_time,
      });
    }, queueId, 'setCamera');

    this.emersyaQueue.run(queueId);
  }

  /**
   * Invoked when a new image file is chosen for a patch.
   *
   * @param {string} combinationSpecificationKey
   * @param {null|File} file
   */
  async onPatchImageChange(combinationSpecificationKey, file) {
    const queueId = randomId();

    if (file === null) {
      await this.updatePatchImage(combinationSpecificationKey, null, queueId, true);
    } else {
      // @todo 2017-12-04 Review this check (we should use the mime-type)
      // @todo 2018-02-28 Use the mime-type from the "accept" in configurator/src/components/PatchConfigurator.js:90
      if (file.size <= 2000000 && (file.name.endsWith("jpg") || file.name.endsWith("png") || file.name.endsWith("jpeg"))) {
        this.setState({ isErrorImagePatchVisible: false });
        await this.updatePatchImage(combinationSpecificationKey, file, queueId, true);
      } else {
        this.setState({ isErrorImagePatchVisible: true });
      }
    }

    this.emersyaQueue.run(queueId);
  }

  /**
   * Invoked when a new text needs to be set.
   *
   * @param {string} combinationSpecificationKey
   * @param {object} text
   */
  async onPatchTextChange(combinationSpecificationKey, text) {
    const queueId = randomId();
    await this.updatePatchText(combinationSpecificationKey, text, queueId, true);
    this.emersyaQueue.run(queueId);
  }

  /**
   * Change the material of the given part.
   *
   * @param {string} specificationKey
   * @param {string} combinationKey
   * @param {string|null} combinationSpecificationKey
   * @param {object} extra
   * @param {number} queueId
   */
  async updatePart(specificationKey, combinationKey, combinationSpecificationKey = null, extra = {}, queueId = randomId()) {
    // @todo 2017-10-08 Maybe extract the following two functions
    const updateCustomTexture = (textures, id) => {
      this.emersyaQueue.queue(() => {
        textures.forEach(([partCode, texture]) => {
          this.postMessageToViewer({
            id: id,
            action: 'updateCustomTexture',
            data: {
              materialTree: partCode,
              materialSettings: 'custom',
              image: texture,
              contents: ['baseColor','opacity']
            }
          });
        });
      }, id, 'updateCustomTexture');

      this.emersyaQueue.queue(() => {
        this.postMessageToViewer({
          id: id,
          action: 'beginTransaction'
        });

        textures.forEach(([partCode, texture]) => {
          this.postMessageToViewer({
            action: 'setMaterialByName',
            materialSettings: `${partCode}/custom`,
          });
        });

        this.postMessageToViewer({
          action: 'endTransaction'
        });
      }, id, 'transaction');
    };

    const setMaterialByName = (materialsByName, id) => {
      this.emersyaQueue.queue(() => {
        this.postMessageToViewer({
          id: id,
          action: 'beginTransaction'
        });

        materialsByName.forEach(([partCode, material]) => {
          this.postMessageToViewer({
            action: 'setMaterialByName',
            materialSettings: `${partCode}/${material}`
          });
        });

        this.postMessageToViewer({
          action: 'endTransaction'
        });
      }, id, 'transaction');

      //  this.emersyaQueue.queue(() => {
      //   materialsByName.forEach(([partCode, material]) => {
      //     this.postMessageToViewer({
      //       id: queueId,
      //       action: 'setMaterialsGroupConfiguration',
      //       groupName: `${partCode}`,
      //       configurationName: `${material}`,
      //   });
      // });
      // }, queueId);
    };

    let productSpecification = this.state.customProduct.product;

    const specification = productSpecification.specification[specificationKey];

    if (specification.combinations[combinationKey] === undefined) {
      console.warn('Invalid combination key.', arguments);
      return;
    }

    specification.active_combination = combinationKey;

    switch (specification.type) {
      case 'PART':
      case 'ACCESSORY':
        this.emersyaQueue.queue(() => {
          this.postMessageToViewer({
            id: queueId,
            action: 'setMaterialsGroupConfiguration',
            groupName: specificationKey,
            // specificationKey is used as combinationSpecificationKey (partCode)
            // as well, which is wrong but works now. We might want to review the
            // data structure (works because we only have one specification for
            // the combination, and it has the same name as the part.
            configurationName: specification.combinations[combinationKey].specification[specificationKey].material,
          });
        }, queueId, 'setMaterialsGroupConfiguration');
        break;

      // Was: if (specification.type === 'CUSTOM_PATCH' && combinationSpecificationKey) {
      case 'CUSTOM_PATCH':
        const combinationSpecification = Object.assign(
          specification.combinations[combinationKey].specification[combinationSpecificationKey],
          { modified: Object.keys(extra).length > 0 },
          extra,
        );

        setMaterialByName([
          [combinationSpecificationKey, specification.combinations[combinationKey].specification[combinationSpecificationKey].material]
        ], queueId);

        // This call an "unnecessary" getPartSpecificationByCode, but is useful
        // to keep the logic in one single place.
        const [width, height] = this.computePatchSize(combinationSpecificationKey);

        // Resize the provided file according to the patch size...
        const base64 = await resizeImage(extra.image, width, height);

        // ...and when converted to base64, update the patch on the 3D model.
        updateCustomTexture([[combinationSpecificationKey, base64]], queueId);

        specification.combinations[combinationKey].specification[combinationSpecificationKey] = combinationSpecification;
        break;

      default:
        console.error('Unknown specification type', specification.type, specification);
    }

    productSpecification.specification[specificationKey] = specification;

    AppActions.updateCustomProduct({ product: productSpecification });
  }

  /**
   * Apply the file to the patch. Clears the patch if `file` is null.
   *
   * @param {string} combinationSpecificationKey
   * @param {null|File} file The file to parse, apply and upload. If the file is
   *     null and dirty is true the file will be deleted from the server.
   * @param {number|undefined} queueId The Emersya queue id
   * @param {boolean} dirty Whether or not this has to be updated on the server.
   */
  async updatePatchImage(combinationSpecificationKey, file, queueId, dirty = false) {
    const detail = this.getPartSpecificationByCode(combinationSpecificationKey);
    const activeCombination = this.getCombinationKeyByPartCode(combinationSpecificationKey);

    if (file === null) {
      this.removePatchImage(detail.name, activeCombination, combinationSpecificationKey, queueId);
    } else {
      const base64 = await imageToBase64(file);

      await this.updatePart(detail.name, activeCombination, combinationSpecificationKey, {
        type: 'image',
        file: base64,
        image: base64,
        dirty,
      }, queueId);
    }

    return true;
  }

  /**
   * Apply the text to a patch. The text information is converted into an image
   * and applied to the patch.
   *
   * @param {string} combinationSpecificationKey
   * @param {object} text
   * @param {number} queueId
   * @param {boolean} dirty
   */
  async updatePatchText(combinationSpecificationKey, text, queueId, dirty = false) {
    const detail = this.getPartSpecificationByCode(combinationSpecificationKey);
    const activeCombination = this.getCombinationKeyByPartCode(combinationSpecificationKey);

    const [width, height] = this.computePatchSize(combinationSpecificationKey);

    [text.font_size, text.stroke_width] = this.computePatchFontSize(
      width, height, text.text, text.font, text.font_dimension, text.stroke_dimension
    );

    const file = this.makeSVGFromTextSpecification(width, height, text);
    const image = this.makeImageFromTextSpecification(width, height, text);

    await this.updatePart(detail.name, activeCombination, combinationSpecificationKey, {
      type: 'text',
      file,
      image,
      text,
      dirty,
    }, queueId);

    return true;
  }

  /**
   * Remove the image from the given patch. Updates the 3D model and the local
   * custom product object.
   *
   * @param {string} specificationKey
   * @param {string} combinationKey
   * @param {string} combinationSpecificationKey
   * @param {number} queueId
   */
  removePatchImage(specificationKey, combinationKey, combinationSpecificationKey, queueId = randomId()) {
    const productSpecification = this.state.customProduct.product;

    this.queuePatchWipe(specificationKey, combinationKey, combinationSpecificationKey, queueId);

    productSpecification.specification[specificationKey].combinations[combinationKey].specification[combinationSpecificationKey] = {
      modified: false,
      material: 'custom',
      type: 'image',
      file: null,
      dirty: true,
      price: productSpecification.specification[specificationKey].combinations[combinationKey].specification[combinationSpecificationKey].price,
    };

    AppActions.updateCustomProduct({ product: productSpecification });
  }

  /**
   * Queues a message to remove the current texture of the given patch.
   *
   * @param {string} specificationKey
   * @param {string} combinationKey
   * @param {string} combinationSpecificationKey
   * @param {number} queueId
   */
  queuePatchWipe(specificationKey, combinationKey, combinationSpecificationKey, queueId) {
    this.emersyaQueue.queue(() => {
      this.postMessageToViewer({
        id: queueId,
        action: 'beginTransaction'
      });

      const material = this.state.customProduct.product.specification[specificationKey].active_combination === combinationKey
        ? 'highlight'
        : 'transparent';

      this.postMessageToViewer({
        action: 'setMaterialByName',
        materialSettings: `${combinationSpecificationKey}/${material}`,
      });

      this.postMessageToViewer({
        action: 'endTransaction'
      });
    }, queueId, 'transaction');

    this.emersyaQueue.queue(() => {
      this.postMessageToViewer({
        id: queueId,
        action: 'updateCustomTexture',
        data: {
          materialTree: combinationSpecificationKey,
          materialSettings: 'custom',
          image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=',
          contents: ['baseColor','opacity']
        }
      });
    }, queueId, 'updateCustomTexture');
  }

  /**
   * Remove the text from the given patch. Updates the 3D model and the local
   * custom product object.
   *
   * @param {string} specificationKey
   * @param {string} combinationKey
   * @param {string} combinationSpecificationKey
   * @param {number} queueId
   */
  removePatchText(specificationKey, combinationKey, combinationSpecificationKey, queueId = randomId()) {
    const productSpecification = this.state.customProduct.product;

    this.queuePatchWipe(specificationKey, combinationKey, combinationSpecificationKey, queueId);

    productSpecification.specification[specificationKey].combinations[combinationKey].specification[combinationSpecificationKey] = {
      modified: false,
      material: 'custom',
      type: 'text',
      text: null,
      dirty: true,
      price: productSpecification.specification[specificationKey].combinations[combinationKey].specification[combinationSpecificationKey].price,
    };

    AppActions.updateCustomProduct({ product: productSpecification });
  }

  /**
   * Loop through all parts and update their materials, load images and texts.
   * SimpleProductSpecification refers to a list of [partCode, material] object,
   * usually used when loading presets or existing customizations.
   *
   * @param simpleProductSpecification
   */
  async updateProductFromSimpleSpecification(simpleProductSpecification) {
    const queueId = randomId();

    this.resetProductSpecificationExtra(queueId);
    this.hideHighlightedPatches(null, queueId);

    const materialGroupConfigurations = [];

    let productSpecification = this.state.customProduct.product;

    for (const simpleSpecificationPart of simpleProductSpecification.specification) {
      const combinationSpecificationKey = simpleSpecificationPart.partCode;
      const specification = this.getPartSpecificationByCode(combinationSpecificationKey);

      if ( ! specification) {
        console.warn('Part %s not found in our database', combinationSpecificationKey);
        continue;
      }

      switch (specification.type) {
        case 'PART':
        case 'ACCESSORY':
          // @todo 2017-12-06
          // Consider improving the this.updatePart function, instead of
          // reimplementing the same logic here.
          specification.active_combination = simpleSpecificationPart.material;
          productSpecification.specification[specification.name] = specification;

          materialGroupConfigurations.push({
            groupName: specification.name,
            configurationName: simpleSpecificationPart.material,
          });
          break;

        case 'CUSTOM_PATCH':
          if (simpleProductSpecification.files[combinationSpecificationKey]) {
            const url = simpleProductSpecification.files[combinationSpecificationKey];
            const file = await fetch(url).then(response => response.blob());

            await this.updatePatchImage(combinationSpecificationKey, file, queueId);
          } else if (simpleProductSpecification.texts[combinationSpecificationKey]) {
            await this.updatePatchText(
              combinationSpecificationKey,
              simpleProductSpecification.texts[combinationSpecificationKey],
              queueId
            );
          } else {
            //
          }
          break;

        default:
          console.warn('Invalid part type %s.', specification.type);
      }
    }

    this.emersyaQueue.queue(() => {
      this.postMessageToViewer({
        id: queueId,
        action: 'setMaterialsGroupsConfigurations',
        values: materialGroupConfigurations,
      });
    }, queueId, 'setMaterialsGroupsConfigurations');

    AppActions.updateCustomProduct({ product: productSpecification });

    this.emersyaQueue.run(queueId);
  }

  /**
   * Highlight many parts and patches.
   * @todo 2017-11-24 Review this to use setHighlight instead
   *
   * @param {Array} partList
   */
  highlightProductPartList(partList) {
    const queueId = randomId();

    // Highlight a normal part...
    this.emersyaQueue.queue(() => {
      this.postMessageToViewer({
        id: queueId,
        action: "setHighlightByName",
        list: partList
      });
    }, queueId, 'setHighlightByName');

    // ...and custom patches. "Highlight" for custom patches are materials
    this.emersyaQueue.queue(() => {
      this.postMessageToViewer({
        id: queueId,
        action: 'beginTransaction'
      });

      partList.forEach(partCode => {
        this.postMessageToViewer({
          action: 'setMaterialByName',
          materialSettings: `${partCode}/highlight`
        });
      });

      this.postMessageToViewer({
        action: 'endTransaction'
      });
    }, queueId, 'transaction');

    this.emersyaQueue.run(queueId);

  }

  /**
   * Hide the highlighted patches and set to highlight the ones of the current
   * active configuration.
   *
   * @param {null|string} patchCode The patch clicked, if not null it
   *     will be used to set the patches of the same configuration to
   *     "highlight" instead of "transparent".
   * @param queueId
   */
  hideHighlightedPatches(patchCode = null, queueId) {
    this.emersyaQueue.queue(() => {
      this.postMessageToViewer({
        id: queueId,
        action: 'beginTransaction'
      });

      const productSpecification = this.state.customProduct.product.specification;

      this.forEachPatchInSpecification(productSpecification, (specificationKey, combinationKey, combinationSpecificationKey) => {
        const combination = productSpecification[specificationKey].combinations[combinationKey].specification[combinationSpecificationKey];

        if (combination.modified) return;

        // This can be falsy when a part is not found or when `patchCode` is
        // undefined.
        const detail = this.getPartSpecificationByCode(patchCode);

        const shouldBeHighlighted = detail &&
          specificationKey === detail.name &&
          combinationKey === detail.active_combination;

        const material = shouldBeHighlighted ? 'highlight' : 'transparent';

        this.postMessageToViewer({
          action: 'setMaterialByName',
          materialSettings: `${combinationSpecificationKey}/${material}`
        });
      });

      this.postMessageToViewer({
        action: 'endTransaction'
      });
    }, queueId, 'transaction');
  }

  forEachPartInSpecification(productSpecification, callback) {
    for (let specificationKey of Object.keys(productSpecification)) {
      this.forEachPartInCombination(productSpecification[specificationKey].combinations, (combinationKey, combinationSpecificationKey) => {
        callback(specificationKey, combinationKey, combinationSpecificationKey);
      });
    }
  }

  forEachPatchInSpecification(productSpecification, callback) {
    for (let specificationKey of Object.keys(productSpecification)) {
      if (productSpecification[specificationKey].type !== 'CUSTOM_PATCH') continue;

      this.forEachPartInCombination(productSpecification[specificationKey].combinations, (combinationKey, combinationSpecificationKey) => {
        callback(specificationKey, combinationKey, combinationSpecificationKey);
      });
    }
  }

  forEachPartInCombination(combinations, callback) {
    for (let combinationKey of Object.keys(combinations)) {
      for (let combinationSpecificationKey of Object.keys(combinations[combinationKey].specification)) {
        callback(combinationKey, combinationSpecificationKey);
      }
    }
  }

  computePatchSize(combinationSpecificationKey) {
    const specification = this.getPartSpecificationByCode(combinationSpecificationKey);

    const size = specification.parts[combinationSpecificationKey].size;
    const ratio = specification.parts[combinationSpecificationKey].ratio;

    // The "size" is the patch width and we get the height dividing by the
    // ratio.
    return [size, size / ratio];
  }

  /**
   *
   * @param {number} width
   * @param height
   * @param {string} text
   * @param {string} family
   * @param {'SMALL'|'MEDIUM'|'BIG'} fontDimension
   * @param {null|'SMALL'|'MEDIUM'|'BIG'} strokeDimension
   * @returns {[number, number]}
   */
  computePatchFontSize(width, height, text, family, fontDimension, strokeDimension) {
    const div = document.createElement('div');

    div.innerHTML = text;
    div.style.display = 'inline-block';
    div.style.fontFamily = family;
    div.style.whiteSpace = 'nowrap';
    div.style.lineHeight = FONTS.find(fontByFamilyName).lineHeight;

    document.body.appendChild(div);

    // @todo 2017-12-12 Consider having custom multipliers per font family.
    const sizeMultiplier = {
      SMALL: 0.35,
      MEDIUM: 0.75,
      BIG: 1.15,
    }[fontDimension];

    let fontSize = Math.max(500, Math.ceil(Math.max(width, height) * 2));
    let strokeWidth = 0;

    const strokeMultiplier = {
      SMALL: 0.0125,
      MEDIUM: 0.025,
      BIG: 0.05,
    };

    function fontByFamilyName(el) {
      return el.family === family;
    }

    /**
     * This function is called
     * @param fontSize
     * @returns {boolean}
     */
    function fincheNonCiSta(fontSize) {
      let clientHeight = parseInt(window.getComputedStyle(div).getPropertyValue('height'), 10);

      return fontSize > 0 && (
        div.clientWidth > (width * sizeMultiplier) - (strokeWidth * 2) ||
        clientHeight > (height * sizeMultiplier) - (strokeWidth * 2)
      );
    }

    do {
      // @todo 2017-12-12
      // Make sure this is not a big performance issue (do-while from 500)
      fontSize--;

      div.style.fontSize = `${fontSize}px`;

      strokeWidth = strokeDimension !== null
        ? fontSize * strokeMultiplier[strokeDimension]
        : 0;
    } while (fincheNonCiSta(fontSize));

    return [fontSize, strokeWidth];
  }

  /**
   * Get a part detail from the given part code.
   *
   * @param {string} partCode The smallest single part of the part (e.g.
   *     "back_3_1")
   * @returns {undefined|object} The detail of the parent part of partCode (e.g.
   *     "back".
   */
  getPartSpecificationByCode(partCode) {
    const productSpecification = this.state.customProduct.product.specification;

    const isParentOfPartCode = key => {
      return Object.keys(productSpecification[key].parts).indexOf(partCode) !== -1;
    };

    return productSpecification[
      Object.keys(productSpecification).filter(isParentOfPartCode)[0]
    ];
  }

  /**
   * Given a combination key returns the partCode.
   * Example: Given "back_3_1" as combination key, returns "back_3"
   *
   * @param {string} combinationSpecificationKey
   * @returns {string|null}
   */
  getCombinationKeyByPartCode(combinationSpecificationKey) {
    const detail = this.getPartSpecificationByCode(combinationSpecificationKey);
    const combinations = this.state.customProduct.product.specification[detail.name].combinations;

    const isParentOfTheCombinationSpecificationKey = combinationKey => {
      return Object.keys(combinations[combinationKey].specification)
        .indexOf(combinationSpecificationKey) !== -1;
    };

    return Object.keys(combinations).filter(isParentOfTheCombinationSpecificationKey)[0];
  }

  /**
   * Reset, for each part, the active combination and the extra information
   * attached after customizing.
   */
  resetProductSpecificationExtra(queueId) {
    const product = this.state.customProduct.product;

    this.forEachPartInSpecification(product.specification, (specificationKey, combinationKey, combinationSpecificationKey) => {
      let combinationSpecification = product.specification[specificationKey].combinations[combinationKey].specification[combinationSpecificationKey];

      if (combinationSpecification.type === 'image') {
        this.removePatchImage(specificationKey, combinationKey, combinationSpecificationKey, queueId);
      } else if (combinationSpecification.type === 'text') {
        this.removePatchText(specificationKey, combinationKey, combinationSpecificationKey, queueId);
      } else {
        product.specification[specificationKey].combinations[combinationKey].specification[combinationSpecificationKey] = {
          material: combinationSpecification.material,
          modified: false,
          price: combinationSpecification.price,
        }
      }
    });

    AppActions.updateCustomProduct({ product });
  }

  /**
   * Invoked when the "Save customization" footer button is clicked. Prepares
   * the payload to send to the server.
   */
  onCustomProductSaveClick() {
    if ( ! this.viewerActive) {
      console.warn('Can not save the product before the viewer is initialized.');
      return;
    }

    const customProductSpecification = {
      productCode: this.state.customProduct.product.code,
      productPresetName: this.state.customProduct.preset,
      perforated: this.state.customProduct.perforated,
      custom_colored: this.state.customProduct.custom_colored,
      screenshots: {},
      specification: [],
      files: [],
      texts: [],
    };

    // @todo 2017-10-05 Refactor this: Create an array of objects representing each customized part
    customProductSpecification.specification = Object.keys(this.state.customProduct.product.specification).filter(specificationKey => {
        return this.state.customProduct.product.specification[specificationKey].active_combination !== null;
      }).map(specificationKey => {
        return Object.keys(
          this.state.customProduct.product.specification[specificationKey].combinations[
            this.state.customProduct.product.specification[specificationKey].active_combination
          ].specification
        ).map(combinationSpecificationKey => {
          const combinationSpecification = this.state.customProduct.product.specification[specificationKey].combinations[
            this.state.customProduct.product.specification[specificationKey].active_combination
          ].specification[combinationSpecificationKey];

          return [combinationSpecificationKey, combinationSpecification];
        });
      }).reduce((carry, parts) => {
        return carry.concat(parts);
      }, []).map(specification => {
        return {
          key: specification[0],
          material: specification[1].material,
          type: specification[1].type,
        };
      });

    this.forEachPatchInSpecification(this.state.customProduct.product.specification, (sk, ck, csk) => {
      let combinationSpecification = this.state.customProduct.product.specification[sk].combinations[ck].specification[csk];

      // If the specification has a "file" property, we push some
      // information to upload it. If the "file" property is null it will be
      // deleted from the server.
      if (combinationSpecification.file !== undefined) {
        customProductSpecification.files.push({
          key: csk,
          dirty: combinationSpecification.dirty,
          type: combinationSpecification.type,
          file: combinationSpecification.file,
        });
      }

      // If the specification has a "text" property, we push some
      // information to save it,
      if (combinationSpecification.text !== undefined) {
        customProductSpecification.texts.push({
          key: csk,
          dirty: combinationSpecification.dirty,
          type: combinationSpecification.type,
          text: combinationSpecification.text,
        });
      }
    });

    if (this.state.customProduct.hash) {
      // Save the specification momentarily, show the Modal which will invoke
      // this.onCreateCustomProductClick(...) once the "Confirm" button is
      // clicked.
      this.customProductSpecification = customProductSpecification;
      //this.setState({ isCustomProductSaveNewOrUpdateModalVisible: true });
      this.onCreateCustomProductClick(customProductSpecification);
    } else {
      this.onCreateCustomProductClick(customProductSpecification);
    }
  }

  /**
   * Post a message to the viewer.
   * Once run() is called the queue is consumed at every "onStateChange" event
   * fired by the viewer.
   *
   * @param {object} message
   * @param {string} targetOrigin
   * @returns {*}
   */
  postMessageToViewer(message, targetOrigin = '*') {
    // console.log('postMessageToViewer', message, message.data, targetOrigin);

    if (this.viewerIframe === null) {
      console.warn('Viewer not initiated yet.');
      return;
    }

    return this.viewerIframe.postMessage(message, targetOrigin);
  }

  /**
   * Identifies the accessory type by its flags.
   *
   * @param flags
   * @returns {*}
   */
  getAccessoryTypeByFlags(flags) {
    switch (true)  {
      case flags.indexOf('ELBOW_PLATE') !== -1:
        return 'ELBOW_PLATE';

      case flags.indexOf('ELBOW_SLIDER') !== -1:
        return 'ELBOW_SLIDER';

      case flags.indexOf('KNEE_SLIDER') !== -1:
        return 'KNEE_SLIDER';

      case flags.indexOf('KNEE_PLATE') !== -1:
        return 'KNEE_PLATE';

      case flags.indexOf('SHOULDER_PLATE') !== -1:
        return 'SHOULDER_PLATE';

      case flags.indexOf('PRINT') !== -1:
        return 'PRINT';

      case flags.indexOf('SPEED_DEMON_CHEST') !== -1:
        return 'SPEED_DEMON_CHEST';

      case flags.indexOf('SPEED_DEMON_GOBBA') !== -1:
        return 'SPEED_DEMON_GOBBA';

      default:
        return '';
    }
  }

  /**
   * For each screenshot to take, turns the camera, take the screenshot and once
   * done with all resolves with an array of screenshots of type {File} in the
   * order they were taken.
   *
   * @param {Array} takes Array of objects representing each screenshot to be
   *     taken.
   * @returns {Promise}
   */
  async takeScreenshots(takes) {
    const queueId = randomId();
    this.hideHighlightedPatches(null, queueId);
    this.emersyaQueue.run(queueId);

    let cameras = [];
    for (const take of takes) {
      cameras.push({
        position:[take.viewpoint.position_x, take.viewpoint.position_y, take.viewpoint.position_z],
        target:[take.viewpoint.target_x, take.viewpoint.target_y, take.viewpoint.target_z],
        up:[take.viewpoint.up_x, take.viewpoint.up_y, take.viewpoint.up_z],
        fov:take.viewpoint.fov,
        transitionTime: take.viewpoint.transition_time
      });
    }
    let screenshots = await this.emersyaBridge.getScreenshots(512, 1024, cameras);

    return screenshots;
  }

  moveCameraToPredefinedViewpoints(viewpointName) {
    const viewpoint = this.state.customProduct.product.viewpoints[this.state.customProduct.product[viewpointName]];

    const queueId = randomId();
    this.emersyaQueue.queue(() => {
      this.postMessageToViewer({
        id: queueId,
        action: 'setCamera',
        position: [viewpoint.position_x, viewpoint.position_y, viewpoint.position_z],
        target: [viewpoint.target_x, viewpoint.target_y, viewpoint.target_z],
        up: [viewpoint.up_x, viewpoint.up_y, viewpoint.up_z],
        fov: viewpoint.fov * 1.8,
        transitionTime: 1500,
      });
    }, queueId, 'setCamera');

    this.emersyaQueue.run(queueId);
  }

  /**
   * Takes two screenshots and invokes onScreenshotsTaken once its done, passing
   * a vector with the two screenshots.
   *
   * @param {function} onScreenshotsTaken
   * @param {function} onError
   */
  takeScreenshotFrontBack(onScreenshotsTaken, onError) {
    const viewpointFrontId = this.state.customProduct.product.viewpoint_front_id;
    const viewpointBackId = this.state.customProduct.product.viewpoint_back_id;
    const viewpointLeftId = this.state.customProduct.product.viewpoint_left_id;
    const viewpointRightId = this.state.customProduct.product.viewpoint_right_id;
    const viewpoints = this.state.customProduct.product.viewpoints;

    this.takeScreenshots([
      { name: 'back', width: 512, height: 1024, viewpoint: viewpoints[viewpointBackId] },
      { name: 'front', width: 512, height: 1024, viewpoint: viewpoints[viewpointFrontId] },
      { name: 'left', width: 512, height: 1024, viewpoint: viewpoints[viewpointLeftId] },
      { name: 'right', width: 512, height: 1024, viewpoint: viewpoints[viewpointRightId] },
    ]).then(onScreenshotsTaken).catch(onError);
  }

  setSelectedHighlightedSpecificationName(name) {
    this.selectedHighlightedSpecificationName = name;

    const materialTreeGroups = name === null ? [] : [name];

    this.postMessageToViewer({
      action: 'setHighlight',
      polylists: [],
      materialTrees: [],
      materialTreeGroups,
    });
  }

  filterBlacks(accessory){
      if(this.state.customProduct.product.id === 12 || this.state.customProduct.product.id === 8){
        if(['black-black'].includes(accessory)){
          return false;
        }
      }
      return true;
  }


  render() {
    let materials = [];

    if (this.state.selectedSpecification) {
      const combinationKeys = Object.keys(this.state.selectedSpecification.combinations);

      materials = Object.keys(this.state.customProduct.product.materials).filter((materialKey) => {
        return (
          combinationKeys.indexOf(materialKey) !== -1 && isNotIronGray(materialKey)
        );
      }).reduce((materials, materialKey) => {
        const material = this.state.customProduct.product.materials[materialKey];

        materials[materialKey] = {
          rgb: material.rgb,
          rgb_brighter: material.rgb_brighter,
          type: material.type
        };

        return materials;
      }, {});
    }
    const symbol = currencySymbol(this.state.customProduct.product.country_id);

    return (
      <div>
        <Header title="Configurator" />

        <Footer
          navigation={this.props.navigation}
          middle={
            <div className="footer__navigator">
              <button className="muted navigator__btn navigator__back" onClick={() => {
                  AppActions.updateCustomProduct({ size: null, sizeType : null});
                  this.props.navigation.navigate('modelColor')
              }}>
                {__('BackButton')}
              </button>

              <button className="muted navigator__btn" onClick={() => this.onCustomProductSaveClick()}>
                {__('Next')}
              </button>
            </div>
          }
        />


        <div className="main is-full-width">
          <ProductPresetSlider
            productCode={this.state.customProduct.product.code}
            onPresetClick={preset => {
              // This call won't work anymore, unless preset has groupName and
              // groupMaterial.
              // this.updateProductFromSimpleSpecification(preset);

              this.setState({
                selectedSpecification: null,
                menuItemActive: null,
              });

              this.setSelectedHighlightedSpecificationName(null);

              AppActions.updateCustomProduct({ preset: preset.name });

              // this.postMessageToViewer({
              //   action: 'applyPreset',
              //   presetName: preset.name,
              // });
            }}
          />

          <ul className="configuratorMenu">
            <li className={`configuratorMenu__item is-restricted ${this.state.menuItemActive == 'leathers' ? 'is-active' : ''}`}>
              <span className={`configuratorMenu__itemTitle u-cu-pointer`} onClick={() => {
                if (this.state.menuItemActive == 'leathers') {
                  this.setState({ selectedSpecification: null });
                  this.setSelectedHighlightedSpecificationName(null);
                }

                this.toggleMenuItem('leathers');
              }}>
                {__('Leathers')}
                <InlineSvg className="configuratorMenu__itemArrow" svg={ConfiguratorMenuItemArrow} />
              </span>
              {this.state.menuItemActive === 'leathers' ? (
                <div className="configuratorMenu__itemPanelContainer">
                  <div className="configuratorMenu__itemPanel">
                    {this.state.selectedSpecification && this.state.selectedSpecification.type === 'PART' ? (
                      <ColorPalette
                        materials={materials}
                        selected={this.state.selectedSpecification.active_combination}
                        onClick={async materialKey => {
                          this.setSelectedHighlightedSpecificationName(null);
                          const queueId = randomId();
                          await this.updatePart(this.state.selectedSpecification.name, materialKey, null, {}, queueId);
                          this.emersyaQueue.run(queueId);
                        }}
                      />
                    ) : (
                      <p className="itemPanel__helpText">{__('Click on the leather part you want to customize on the 3D model.')}</p>
                    )}
                  </div>
                </div>
              ) : null}
            </li>

            {this.state.accessoryTypeList.length > 0 && <li className={this.state.accessoryTypeList.indexOf(this.state.menuItemActive) !== -1 ? 'is-active' : ''}>
              <span className="configuratorMenu__itemTitle u-cu-pointer" onClick={() => {
                if (this.state.accessoryTypeList.indexOf(this.state.menuItemActive) !== -1) {
                  this.closeMenuItem(this.state.menuItemActive);
                }
              }}>
                {__('Accessories')}
              </span>
              <ul>
                {this.state.accessoryTypeList.map(accessoryType => {
                  return (
                    <li key={accessoryType} className={`configuratorMenu__item is-restricted ${this.state.menuItemActive === accessoryType ? 'is-active' : ''}`}>
                      <span className={`configuratorMenu__itemTitle configuratorMenu__itemTitle--small u-cu-pointer`} onClick={() => {
                        this.toggleMenuItem(accessoryType);
                        this.setState({ selectedSpecification: null });
                        this.setSelectedHighlightedSpecificationName(null);
                      }}>
                        {__(accessoryType)}
                        <InlineSvg className="configuratorMenu__itemArrow" svg={ConfiguratorMenuItemArrow} />
                      </span>
                      {this.state.menuItemActive === accessoryType ? (
                        <div className="configuratorMenu__itemPanelContainer accessoriesContainer">
                          <div className="configuratorMenu__itemPanel">
                            {this.state.selectedSpecification && this.state.selectedSpecification.type === 'ACCESSORY' ? (
                              <AccessoryPalette
                                materials={this.state.customProduct.product.materials}
                                priceTiers={this.state.customProduct.product.price_tiers}
                                combinations={this.state.selectedSpecification.combinations}
                                accessoryType={accessoryType}
                                selectedSpecification={this.state.selectedSpecification}
                                idProduct={this.state.customProduct.product.id}
                                onClick={async (selectedSpecification, combinationKey) => {
                                  const queueId = randomId();
                                  await this.updatePart(selectedSpecification.name, combinationKey, null, {}, queueId);
                                  this.emersyaQueue.run(queueId);
                                }}
                              />
                            ) : (
                              <p className="itemPanel__helpText accessories_helpText">{__('Click on the accessory you want to customize on the 3D model.')}</p>
                            )}
                          </div>
                        </div>
                      ) : null}
                    </li>
                  );
                })}
              </ul>
            </li>}
            {Object.keys(this.state.customProduct.product.specification).filter(specificationKey => {
              return this.state.customProduct.product.specification[specificationKey].type === 'CUSTOM_PATCH';
            }).length > 0 &&
            <li className={`configuratorMenu__item configuratorMenu__item--patches ${this.state.menuItemActive === 'patches' ? 'is-active' : ''}`}>
              <span className="configuratorMenu__itemTitle u-cu-pointer" onClick={() => {
                if ( ! this.canInteractWithViewer()) {
                  return;
                }

                this.toggleMenuItem('patches');
                this.setState({ selectedSpecification: null });
                this.setSelectedHighlightedSpecificationName(null);
              }}>
                {__('Patches')}
                <InlineSvg className="configuratorMenu__itemArrow" svg={ConfiguratorMenuItemArrow} />
              </span>
              {this.state.menuItemActive === 'patches' ? (
                <div className="configuratorMenu__itemPanelContainer panel--Scrollable">
                  <div className="configuratorMenu__itemPanel">
                    <div className="patchLogoContainer">
                      <Dropdown
                        onChange={specificationKey => {
                          // Reset Image Error
                          this.setState({ isErrorImagePatchVisible: false });

                          if (this.state.customProduct.product.specification[specificationKey]) {
                            this.onPatchClick(specificationKey, this.state.customProduct.product.specification[specificationKey].active_combination);
                          }
                        }}
                        defaultText={__('Select the patch to customize…')}
                        selected={this.state.selectedSpecification ? this.state.selectedSpecification.name : ''}
                        options={Object.keys(this.state.customProduct.product.specification).filter(specificationKey => {
                          return this.state.customProduct.product.specification[specificationKey].type === 'CUSTOM_PATCH';
                        }).map(specificationKey => {
                          return {
                            value: specificationKey,
                            text: (
                              <span>
                              {__(this.state.customProduct.product.specification[specificationKey].label)}
                                {/* @todo 2017-10-02 Temporary logic to demonstrate this can be done. Refactor. */}
                                {Object.keys(
                                  this.state.customProduct.product.specification[specificationKey].combinations,
                                ).some(ck => {
                                  return Object.keys(
                                    this.state.customProduct.product.specification[specificationKey].combinations[ck].specification,
                                  ).filter(csk => {
                                    return this.state.customProduct.product.specification[specificationKey].combinations[ck].specification[csk].modified;
                                  }).length;
                                }) ? <span><div className="circle"><span>&#10003;</span></div></span> : null}
                            </span>
                            ),
                          };
                        })}
                      />

                      <div style={{fontSize: '.55rem', paddingBottom: '.5rem'}}>{__('Click here to know more about patches')}
                      <button className="muted icon icon-patch"
                          onClick={(event) => {
                            event.stopPropagation();
                            this.setState({ isPatchModalVisible: true })
                          } }>
                          <InlineSvg className="dropdown-svg" svg={InfoIcon} />
                      </button>
                      </div>
                    </div>
                    {this.state.selectedSpecification && Object.keys(this.state.selectedSpecification.combinations).length > 1 ? (
                      <div className="patchOptionsContainer">
                        <Dropdown
                          onChange={combinationKey => this.onPatchClick(this.state.selectedSpecification.name, combinationKey)}
                          defaultText={__('Select the patch configuration…')}
                          selected={this.state.selectedSpecification.active_combination}
                          options={Object.keys(this.state.selectedSpecification.combinations).map(combinationKey => {
                            return {
                              value: combinationKey,
                              text: __(combinationKey.charAt(0).toUpperCase() + combinationKey.slice(1)),
                            };
                          }).sort((a, b) => b.value < a.value)}
                        />
                      </div>
                    ) : null}

                    {this.state.selectedSpecification ? (
                      <div>
                        <Tabs forceRenderTabPanel={true} selectedIndex={this.state.patchConfigurationIndex} onSelect={index => this.setState({ patchConfigurationIndex: index })}>
                          {Object.keys(this.state.selectedSpecification.combinations[this.state.selectedSpecification.active_combination].specification).length > 1 ? (
                            <TabList>
                              {Object.keys(this.state.selectedSpecification.combinations[this.state.selectedSpecification.active_combination].specification).map((sk, i) => (
                                <Tab>{__(`${i + 1}`)}</Tab>
                              ))}
                            </TabList>
                          ) : (
                            <TabList style={{ display: 'none' }}>
                              <Tab/>
                            </TabList>
                          )}

                          <form ref="patchImageForm" className="patchImageForm" onSubmit={e => e.preventDefault()}>
                            {Object.keys(this.state.selectedSpecification.combinations[this.state.selectedSpecification.active_combination].specification).map(sk => {
                              const combination = this.state.selectedSpecification.combinations[this.state.selectedSpecification.active_combination];

                              return (
                                <TabPanel key={sk}>
                                  <PatchConfigurator
                                    patchKey={sk}
                                    materials={this.state.customProduct.product.materials}
                                    patchSpecification={combination.specification[sk]}
                                    onImageChange={file => this.onPatchImageChange(sk, file)}
                                    onTextChange={text => this.onPatchTextChange(sk, text)}
                                    imageError={this.state.isErrorImagePatchVisible}
                                  />
                                </TabPanel>
                              );
                            })}
                          </form>
                        </Tabs>
                      </div>
                    ) : null}
                  </div>
                </div>
              ) : null}
            </li>
            }
            {/*<li className={`configuratorMenu__item configuratorMenu__item--patches ${this.state.menuItemActive === 'patches' ? 'is-active' : ''}`} >
              <button style={{display:'block', margin:"auto"}}className="btn btn-sm btn-primary" onClick={() => this.moveCameraToPredefinedViewpoints("viewpoint_front_id")}>
                {__('front')}
              </button>
              <div style={{display:'block', margin:"auto", width:"5.6rem"}}>
              <button style={{display:'inline'}} className="btn btn-sm btn-primary" onClick={() => this.moveCameraToPredefinedViewpoints("viewpoint_left_id")}>
                {__('left')}
              </button>
              <button style={{display:'inline', opacity:'0'}} className="btn btn-sm btn-primary" disabled={true}>
                {__('        ')}
              </button>
              <button style={{display:'inline'}} className="btn btn-sm btn-primary" onClick={() => this.moveCameraToPredefinedViewpoints("viewpoint_right_id")}>
                {__('right')}
              </button>
              </div>
              <button style={{display:'block', margin:"auto"}} className="btn btn-sm btn-primary" onClick={() => this.moveCameraToPredefinedViewpoints("viewpoint_back_id")}>
                {__('back')}
              </button>
            </li> */}
          </ul>

          <Modal
            visible={this.state.isCustomProductSaveNewOrUpdateErrorModalVisible}
            width={600}
            onCloseClick={() => this.setState({ isCustomProductSaveNewOrUpdateErrorModalVisible: false })}
            actions={
              <div className="text-center">
                <button className="btn btn-primary" onClick={() => {
                  this.setState({ isCustomProductSaveNewOrUpdateErrorModalVisible: false });
                  this.onCustomProductSaveClick();
                }}>{__('Try again')}</button>
              </div>
            }
          >
            <div className="text-center" style={{ paddingRight: 50, paddingLeft: 50 }}>
              <h1>{__('An error occurred')}</h1>
              <p>{__("There was an error while taking your configuration's screenshots.")}</p>
            </div>
          </Modal>

          <Modal
            visible={this.state.isCustomProductSaveNewOrUpdateModalVisible}
            width={705}
            onCloseClick={() => this.setState({ isCustomProductSaveNewOrUpdateModalVisible: false })}
            actions={
              <div className="text-center">
                {(!this.state.customProduct.locked) ? (
                  <button className="btn btn-primary" onClick={() => {
                    this.onUpdateCustomProductClick(this.state.customProduct.hash, this.customProductSpecification);
                  }}>{__('Update')}</button>
                ) : null}
                <button className="btn btn-primary" onClick={() => {
                  this.onCreateCustomProductClick(this.customProductSpecification);
                }}>{__('New')}</button>
              </div>
            }
          >
            <div className="productPresetModal">
              <h1>{__('Do you want to update the customization or create a new one?')}</h1>
              <h2>{__('Update the customization or create a new one.')}</h2>
            </div>
          </Modal>
          <Modal
            visible={this.state.isPatchModalVisible}
            onCloseClick={() => this.setState({ isPatchModalVisible: false })}
            style={{maxWidth:'20rem'}}
            noFooterPadding={true}
          >
            <div className="patchModal">
              <h1>{__('Patches')}</h1>
              <div>
                {__('Please note that we will not be able to add the following logos and trade marks: Ducati, Monster, RedBull and VR46. Depending on content and quality of images, our Team will tell you which of the following add-ons will be used:')}
              </div>
              <div className="patchDetail">
                <div className="patchDetail__image">
                  <img src={LeatherPatchSample} />
                </div>
                <div className="patchDetail__info">
                  <h3>{__('Leather Patch')}</h3>
                  {shouldShowPrice(CountryStore.getState()) &&(
                    <div className="patchDetail__info__price">
                      <span>{parseFloat(roundNumber(this.state.customProduct.product.leather_patch_price)).toLocaleString(undefined, {minimumFractionDigits: 2})} {shouldShowPrice(CountryStore.getState()) ? symbol : ""}</span>
                    </div>
                   )}
                  <div className="patchDetail__info__text">
                    {__('Offers the highest level of perceived quality and the most durability, but it has design limitations.')}
                  </div>
                </div>
              </div>
              <div className="patchDetail">
                <div className="patchDetail__image">
                  <img src={TransferSample} />
                </div>
                <div className="patchDetail__info">
                  <h3>{__('Transfer')}</h3>
                  {shouldShowPrice(CountryStore.getState()) &&(
                    <div className="patchDetail__info__price">
                      <span>{parseFloat(roundNumber(this.state.customProduct.product.transfer_price)).toLocaleString(undefined, {minimumFractionDigits: 2})} {shouldShowPrice(CountryStore.getState()) ? symbol : ""}</span>
                    </div>
                   )}
                  <div className="patchDetail__info__text">
                    {__('It\'s an ink printing onto a faux piece of leather that offers complete design freedom, but has a lower perceived quality level, and reduced durability.')}
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      </div>
    );
  }

  makeSVGFromTextSpecification(width, height, text) {
    const context = new canvas2svg(width, height);

    // Draw canvas boundaries, useful when exporting to SVG
    context.rect(0, 0, width, height);
    context.lineWidth = 1;
    context.strokeStyle = 'rgba(0,0,0,0)';
    context.stroke();

    context.textAlign = 'center';
    context.textBaseline = 'middle';
    if(text.material) {
        context.fillStyle = this.state.customProduct.product.materials[text.material].rgb;
    }
    context.font = `${+text.font_size}px ${text.font}`;

    // The strokeText and fillText will result in an useless layer when
    // exporting from SVG. We need both to draw the text correctly on the canvas
    // though.
    if(text.stroke_material) {
        context.strokeStyle = this.state.customProduct.product.materials[text.stroke_material].rgb;
    }
    context.lineWidth = text.stroke_width * 2;
    context.strokeText(text.text, width / 2, height / 2);

    context.fillText(text.text, width / 2, height / 2);

    return 'data:image/svg+xml;base64,' + btoa('<?xml version="1.0" encoding="UTF-8"?>' + context.getSerializedSvg());
  }

  makeImageFromTextSpecification(width, height, text) {
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;

    const context = canvas.getContext('2d');

    context.textAlign = 'center';
    context.textBaseline = 'middle';
    if(text.material) {
        context.fillStyle = this.state.customProduct.product.materials[text.material].rgb;
    }
    context.font = `${+text.font_size}px ${text.font}`;

    if (text.stroke_width) {
      context.strokeStyle = this.state.customProduct.product.materials[text.stroke_material].rgb;
      context.lineWidth = text.stroke_width * 2;
      context.strokeText(text.text, width / 2, height / 2);
    }

    context.fillText(text.text, width / 2, height / 2);

    return canvas.toDataURL();
  }
}

export default Configurator;



// WEBPACK FOOTER //
// ./src/screens/Configurator.js